import { Component } from 'react';

export default class FormComponentItem extends Component {
  constructor() {
    super();
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler() {
    const { onChangeCallback, value } = this.props;

    onChangeCallback(value);
  }
}
